/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { popularCities, searchStations } from './RailAutoComplete';

function SearchHeader({ value, onSearchTextChange, onClick }) {
  return (
    <div className={'searchHeader'}>
      <span className={'backIcon'} onClick={() => onClick('')} />
      <input
        value={value}
        onChange={(event) => onSearchTextChange(event.currentTarget.value)}
        autoFocus={true}
        className={'searchText'}
        placeholder="Enter City, Station name or Station Code"
      />
    </div>
  );
}

SearchHeader.propTypes = {
  value: PropTypes.string.isRequired,
  onSearchTextChange: PropTypes.func.isRequired
};

function StationListItem({ station, onClick }) {
  return (
    <div className={'stationListItem'} onClick={() => onClick(station)}>
      <div className={'cityName'}>{`${station.city}, ${station.state}`}</div>
      <div className={'stationInfo'}>
        <span className={'stationName'}>{station.stationName}</span>
        <span className={'stationCode'}>{station.stationCode}</span>
      </div>
    </div>
  );
}

StationListItem.propTypes = {
  station: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export function CityPicker({ onCitySelected }) {
  const [searchText, setSearchText] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  useEffect(() => {
    if (searchText.length > 1) {
      searchStations(searchText).then((results) => {
        setSearchResults(results.data.r);
      });
    } else if (searchText.length === 0) {
      setSearchResults(popularCities[0].citieslist);
    }
  }, [searchText]);
  return (
    <div className={'cityPicker'}>
      <SearchHeader value={searchText} onSearchTextChange={setSearchText} onClick={onCitySelected} />
      {searchResults &&
        searchResults.map((value) => (
          <StationListItem key={value.stationCode} station={value} onClick={onCitySelected} />
        ))}
    </div>
  );
}

CityPicker.propTypes = {
  onCitySelected: PropTypes.func.isRequired
};
